// extracted by mini-css-extract-plugin
module.exports = {"botonNovedad":"Novedad_botonNovedad__i-U2o","focus":"Novedad_focus__U88iy","active":"Novedad_active__2ETat"};